// extracted by mini-css-extract-plugin
module.exports = {"retailer":"styles_retailer__2z7BB"};